import BillingPage from '../pages/admin/BillingPage'

// Settings > Billing shows the same page as /admin/billing.
export default function RestaurantBillingPanel() {
  return <BillingPage embedded />
}
